import { BaseTable, Loading, TableHeader } from "components";
import { Fragment } from "react";
import { useList } from "./utils";
import moment from "moment";
import { APPROVAL, convertNumber } from "utils";

export function TabTransfers(props: {
    dateFrom: string;
    dateEnd: string;
}): JSX.Element {
    const productId = localStorage.getItem("prdId")

    const { data, isLoading } = useList({
            start_date: props.dateFrom,
            end_date: props.dateEnd,
            product_id: Number(productId)
        });

    const totalReceived = data.reduce((prev, curr) => prev + Number(curr?.qty_received ?? 0), 0);
    const totalRejected = data.reduce((prev, curr) => prev + Number(curr?.qty_rejected ?? 0), 0);
    const totalTransfered = data.reduce((prev, curr) => prev + Number(curr?.qty_transfer ?? 0), 0);

    return (
        <Fragment>
            <section className="mt-2">
                <div className="overflow-x-auto">
                    <BaseTable className="border-transparent">
                        <TableHeader>
                            <tr className="uppercase">
                                <th>NO</th>
                                <th>TRANSFER ID#</th>
                                <th>DATE</th>
                                <th>SOURCE LOCATION</th>
                                <th>QTY TRANSFERED</th>
                                <th>DESTINATION LOCATION</th>
                                <th>RECEIVED</th>
                                <th>REJECTED</th>
                                <th>TRADER</th>
                                <th>TRANSFER</th>
                                <th>APPROVED</th>
                            </tr>
                        </TableHeader>
                        <tbody>
                            {!data.length || isLoading
                                ? <tr><td colSpan={11} className="text-center"><Loading loading={isLoading} errorText={isLoading ? "" : "No data available"} /></td></tr>
                                : data.map((val, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{val?.trx_code ?? ""}</td>
                                        <td>{moment(val?.transaction_date).format("DD/MM/YYYY")}</td>
                                        <td>{val.location_from.location_name}</td>
                                        <td className="text-center">{val.qty_transfer ? convertNumber(val.qty_transfer).intoNormalAmount : "0"}</td>
                                        <td>{val.location_to.location_name}</td>
                                        <td className="text-center">{val.qty_received ? convertNumber(Number(val.qty_received)).intoNormalAmount : ""}</td>
                                        <td className="text-center">{val.qty_rejected ? `${convertNumber(Number(val.qty_rejected))?.intoNormalAmount}` : ""}</td>
                                        <td>{val.employee.employee_name}</td>
                                        <td>{Number(val.transfer_status) === 1 ? "Open" : Number(val.transfer_status) === 2 ? "Closed" : Number(val.transfer_status) === 3 ? "Completed" : "-"}</td>
                                        <td>{APPROVAL[val.approval_status]}</td>
                                    </tr>
                                ))
                            }

                            <tr className="font-bold">
                                <td colSpan={4} className="text-right">SUMMARY</td>
                                <td className="text-center">{totalTransfered ? `${convertNumber(totalTransfered)?.intoNormalAmount}` : "0"}</td>
                                <td></td>
                                <td className="text-center">{totalReceived ? `${convertNumber(totalReceived)?.intoNormalAmount}` : "0"}</td>
                                <td className="text-center">{totalRejected ? convertNumber(totalRejected)?.intoCurrency : "0"}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                        <tfoot >

                        </tfoot>
                    </BaseTable>
                </div>
            </section>
        </Fragment>
    )
}